module.exports = __webpack_public_path__ + "src/assets/img/no-img.af02f5c2.png";